



















































import { Component, Vue } from 'vue-property-decorator';
import { mdbBtn, mdbIcon, mdbTooltip, mdbRow, mdbCol, mdbCard, mdbCardBody, mdbCardTitle, mdbView, mdbMask } from '@folky-tools/mdbvue';
import { authorizationManagerService, usersService, businessesService, GetBusinessFormConfigOutputDto, UpdateBusinessFormConfigInputDto, notificationsService } from '@/services';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';

@Component({
    components: {
        mdbBtn,
        mdbIcon,
        mdbTooltip,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardBody,
        mdbCardTitle,
        mdbView,
        mdbMask,
        FormModal: () => import('@/components/shared/FormModal.vue'),
        EditContactSettings: () => import('@/components/businesses/EditContactSettings.vue'),
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class BusinessContactSettingsView extends Vue {
    private canEditBusiness = false;
    private businessContactSettings: GetBusinessFormConfigOutputDto = { visible: false, notes: '' };
    private businessContactSettingsCopy: GetBusinessFormConfigOutputDto = { visible: false, notes: '' };
    private businessContactSettingsInput: UpdateBusinessFormConfigInputDto = { businessId: 0, visible: false, notes: '' };

    private showEditContactSettings: boolean = false;
    private savingContactSettings: boolean = false;
    private pageContentLoaded: boolean = false;

    private async created(): Promise<void> {
        this.canEditBusiness = authorizationManagerService.isAdmin || authorizationManagerService.authorizedBusinessIdsToEdit.some(id => id === +this.$route.params.id);
        this.businessContactSettings = await businessesService.getBusinessFrontPageFormConfig(+this.$route.params.id);
        this.businessContactSettingsCopy = { ...this.businessContactSettings };
    }

    private async mounted(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.businesses.businessContactSettingsView.title', this.$route.query.businessName ? this.$route.query.businessName : '...');

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Businesses,
                scope: UserActionScopeType.ContactSettings,
                entityId: +this.$route.params.id
            })
        );
        setTimeout(() => {
            this.pageContentLoaded = true;
        }, 10);
    }

    private editContactSettings(): void {
        this.showEditContactSettings = true;
    }

    private async saveContactSettings(): Promise<void> {
        this.savingContactSettings = true;
        this.businessContactSettingsInput.businessId = +this.$route.params.id;
        this.businessContactSettingsInput.visible = this.businessContactSettings.visible;
        this.businessContactSettingsInput.notes = this.businessContactSettings.notes;
        try {
            await businessesService.updateBusinessFrontPageFormConfig(this.businessContactSettingsInput);
            this.showEditContactSettings = false;
            this.businessContactSettingsCopy = { ...this.businessContactSettings };

            notificationsService.showToastSuccessNotification('views.businesses.businessContactSettingsView.notifications.saveContactSettings.success');

            await usersService.logUserAction(
                new UserActionLogInfo({
                    type: UserActionType.HasChanged,
                    entity: UserActionEntityType.Businesses,
                    scope: UserActionScopeType.ContactSettings,
                    entityId: +this.$route.params.id
                })
            );

            return;
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingContactSettings = false;
        }
    }

    private closeContactSettingsEdition(): void {
        this.businessContactSettings = { ...this.businessContactSettingsCopy };
        this.showEditContactSettings = false;
    }
}
